// extracted by mini-css-extract-plugin
export default {"wrapper":"EnvironmentWidget_wrapper__hicwi"};